import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import filtersChoiceSelector from '@/features/choice/selectors/filters';
import filtersDataSelector from '@/features/filters/selectors/data';
import { IChoiceFilters } from '@/interfaces/choice.interfaces';
import { IExtendedFilterCollectionItem } from '@/interfaces/filters.interfaces';
import compactArray from '@/utils/compactArray';
import instanceOfReference from '@/utils/instanceOfReference';

const formattedFiltersChoiceSelector = createSelector(
  [filtersDataSelector, filtersChoiceSelector],
  (filtersData, filtersChoice) => {
    const formattedFiltersChoice: IChoiceFilters = {};
    const { data: filtersRawItem } = filtersData;

    for (const [filterKey, filterValue] of Object.entries(filtersChoice)) {
      const filterValues = filtersRawItem?.data?.[filterKey];
      const arrayFilterValues = Array.isArray(filterValues)
        ? filterValues
        : [filterValues];

      if (instanceOfReference(arrayFilterValues?.[0])) {
        const filterItemValues = arrayFilterValues as IExtendedFilterCollectionItem[];

        if (Array.isArray(filterValue)) {
          formattedFiltersChoice[filterKey] = compactArray(
            filterValue.map(value => {
              const filterItemValue = filterItemValues.find(
                itemValue => itemValue.id === value,
              );
              return filterItemValue?.slug ?? filterItemValue?.id;
            }),
          );
        } else {
          const filterItemValue = filterItemValues.find(
            itemValue => itemValue.id === filterValue,
          );
          if (filterItemValue?.collection_id !== COLLECTION_IDS.dealersClusters) {
            formattedFiltersChoice[filterKey] =
              filterItemValue?.slug ?? filterItemValue?.id;
          }
        }
      } else {
        formattedFiltersChoice[filterKey] = filterValue;
      }
    }

    return formattedFiltersChoice;
  },
);

export default formattedFiltersChoiceSelector;
